import { openDB } from 'idb';

const dbName = 'app';
const pageStore = 'pageStates';
const proposalStore = 'proposals';

const initDB = async () => {
  const db = await openDB(dbName, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(pageStore)) {
        db.createObjectStore(pageStore);
      }
      if (!db.objectStoreNames.contains(proposalStore)) {
        db.createObjectStore(proposalStore);
      }
    },
  });
  return db;
};

// ===================== PAGE STATES =====================

export const getPageState = async (key: string) => {
  const db = await initDB();
  return await db.get(pageStore, key);
};

export const savePageState = async (key: string, state: any) => {
  const db = await initDB();
  await db.put(pageStore, { ...state, timestamp: Date.now() }, key);
};

export const deletePageState = async (key: string) => {
  const db = await initDB();
  await db.delete(pageStore, key);
};

export const deletePageStateByPartialKey = async (partialKey: string) => {
  const db = await initDB();
  const allKeys = await db.getAllKeys(pageStore);
  const matchingKeys = allKeys.filter(
    (key) => typeof key === 'string' && key?.toLowerCase().includes(partialKey?.toLowerCase()),
  );

  await Promise.all(matchingKeys.map((key) => db.delete(pageStore, key)));
};

// ===================== PROPOSALS =====================

export const getProposal = async (key: string) => {
  const db = await initDB();
  return await db.get(proposalStore, key);
};

export const saveProposal = async (key: string, proposal: any) => {
  const db = await initDB();
  await db.put(proposalStore, { ...proposal, timestamp: Date.now() }, key);
};

export const deleteProposal = async (key: string) => {
  const db = await initDB();
  await db.delete(proposalStore, key);
};
